export const _spacing = {
  $0: 0,
  $0_5: 2,
  $1: 4,
  $1_5: 6,
  $2: 8,
  $2_5: 10,
  $3: 12,
  $3_5: 14,
  $4: 16,
  $4_5: 18,
  $5: 20,
  $6: 24,
  $7: 28,
  $8: 32,
  $9: 36,
  $10: 40,
  $11: 44,
  $12: 48,
  $13_5: 54,
  $14: 56,
  $15: 60,
  $16: 64,
  $17: 68,
  $17_5: 70,
  $18: 72,
  $19: 76,
  $20: 80,
  $24: 96,
  $32: 128,
  $40: 160,
  $48: 192,
  $56: 224,
  $64: 256,
  $72: 288,
  $80: 320,
  $90: 360,
  $96: 384,
  $150: 600,
};
